import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import moment from 'moment';

import selectors from 'shared/store/selectors';

import './TabContents.scss';


const SubPortfolio = ({
  intl, fullName, nationality, civilId, address, isAuthorityToDeal, isPOAholder, poaName, poaNationality, poaAddress, applicantId,
}) => (
  <div className="tab-contents">
    <header>
      <h5><FormattedHTMLMessage id="subpf.header" values={{ subPfNo: `${10000 + applicantId}-N-IID-01` }} /></h5>
    </header>

    <article>
      <p>
        <FormattedHTMLMessage id="subpf.p1" values={{ day: moment().format('Do'), month: moment().format('MMMM'), year: moment().year() }} />
      </p>
      <p><FormattedHTMLMessage id="ndpf.p2" /></p>
      <p>
        {(isPOAholder === intl.formatMessage({ id: 'no' })) && (
        <FormattedHTMLMessage
          id="ndpf.p3"
          values={{
            fullName, nationality, civilId, address,
          }}
        />
        )}
        {isAuthorityToDeal === 'legalGuardian' && (
        <FormattedHTMLMessage
          id="ndpf.p3.minor"
          values={{
            fullName, nationality, civilId, address, poaName, poaNationality, poaAddress,
          }}
        />
        )}
        {isPOAholder === intl.formatMessage({ id: 'yes' }) && (
        <FormattedHTMLMessage
          id="ndpf.p3.legalAttorney"
          values={{
            fullName, nationality, civilId, address, poaName, poaNationality, poaAddress,
          }}
        />
        )}
      </p>

      <h5><FormattedHTMLMessage id="ndpf.preamble" /></h5>
      <p><FormattedHTMLMessage id="subpf.preamble.p1" /></p>
      <p><FormattedHTMLMessage id="subpf.preamble.p2" /></p>
      <p><FormattedHTMLMessage id="subpf.preamble.p3" /></p>

      <p><FormattedHTMLMessage id="subpf.article.1" /></p>
      <p><FormattedHTMLMessage id="subpf.article.1.p1" /></p>

      <p><FormattedHTMLMessage id="subpf.article.2" /></p>
      <p><FormattedHTMLMessage id="subpf.article.2.p1" /></p>
      <p><FormattedHTMLMessage id="subpf.article.2.p2" /></p>
      <p><FormattedHTMLMessage id="subpf.article.2.p3" /></p>

      <p><FormattedHTMLMessage id="subpf.article.3" /></p>
      <p><FormattedHTMLMessage id="subpf.article.3.1" /></p>
      <p><FormattedHTMLMessage id="subpf.article.3.p1" /></p>
      <p><FormattedHTMLMessage id="subpf.article.3.p1.1" /></p>
      <p><FormattedHTMLMessage id="subpf.article.3.p2" /></p>
      <p><FormattedHTMLMessage id="subpf.article.3.p2.1" /></p>
      <br />
      <p><FormattedHTMLMessage id="ndpf.article.22" /></p>
    </article>
  </div>
);

const mapStateToProps = state => ({
  fullName: selectors.getFullName(state),
  nationality: selectors.getNationality(state),
  civilId: selectors.getCivilId(state),
  address: selectors.getHomeAddress(state),

  isAuthorityToDeal: selectors.getAsiIsAuthorityToDeal(state),
  isPOAholder: selectors.getAsiIsPOAholder(state),

  poaName: selectors.getAsiName(state),
  poaAddress: selectors.getAsiAddress(state),
  poaNationality: selectors.getAsiNationality(state),
});

export default connect(mapStateToProps)(injectIntl(SubPortfolio));
